import React from "react";
import { bool, func, shape } from "prop-types";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomText from "pages/_components/CustomText/CustomText";
import { Col, Row } from "react-bootstrap";
import * as i18nUtils from "util/i18n";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Credential from "pages/_components/fields/credentials/Credential";
import Button from "pages/_components/Button";

const FORM_ID = "login.step2";

const SlideDesvincularToken = ({
    slideIsVisible,
    closeSlide,
    isMobile,
    deviceDelete,
    eliminarDispotivo,
    setFormRef2,
}) => {
    const { shortLabel } = deviceDelete;

    const formikValidateProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            password: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                password: Yup.string().required(i18nUtils.get("onboarding.step.verifySMS.code.error.empty")),
            }),
        onSubmit: (event) => {
            eliminarDispotivo(event.password);
        },
    };

    return (
        <Drawer openSidebar={slideIsVisible} toggleSidebar={closeSlide}>
            <div className="container full-width">
                <h1 className="title-content text-center">
                    <CustomText text="Desvincular Token" />
                </h1>
                <Row>
                    <Col xs={12} md={10} mdOffset={1} className="mt-8">
                        <CustomText text="¿Estas seguro que querés desvincular este dispositivo?" />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} mdOffset={1} className="box success py-6 px-6 my-8">
                        <Row>
                            <Col xs={4} md={4}>
                                <CustomText text={i18nUtils.get("preferences.myToken.device", "Dispositivo ")} />
                            </Col>
                            <Col xs={8} md={8} className="text-right">
                                <CustomText 
                                    className="font-size-lg font-weight-700" 
                                    text={shortLabel} 
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Formik ref={(el) => setFormRef2(el)} {...formikValidateProps}>
                    {() => (
                        <Form className="above-the-fold">
                            <Row>
                                <Col xs={12} md={10} mdOffset={1}>
                                    <Field
                                        name="password"
                                        hideLabel={!isMobile}
                                        copyEnabled={false}
                                        component={Credential}
                                        autoFocus
                                        idForm={FORM_ID}
                                    />
                                </Col>
                                <Col xs={12} md={10} mdOffset={1}>
                                    <Button
                                        type="submit"
                                        className="mt-8"
                                        bsStyle="primary"
                                        defaultLabelText="Desvincular"
                                        block
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </div>
        </Drawer>
    );
};
SlideDesvincularToken.propTypes = {
    slideIsVisible: bool.isRequired,
    setFormRef2: func.isRequired,
    eliminarDispotivo: func.isRequired,
    closeSlide: func.isRequired,
    isMobile: bool.isRequired,
    deviceDelete: shape({}).isRequired,
};

SlideDesvincularToken.defaultProps = {};

export default SlideDesvincularToken;
